import React from 'react';
import { ADMIN_PALETTE, ADMIN_TAB_GROUPS, TAB_COUNT_TONE, TabPill } from './adminDesignSystem';

export const AdminPanelTabBar = ({ activeTab, onTabClick, tabCounts, isMainAdmin = false }) => (
  <div
    data-testid="admin-tabs-bar"
    style={{
      display: 'flex',
      gap: 10,
      padding: '10px 12px',
      overflowX: 'auto',
      background: ADMIN_PALETTE.surface,
      border: `1px solid ${ADMIN_PALETTE.border}`,
      borderRadius: 20,
      marginBottom: 14,
      alignItems: 'stretch',
      flexWrap: 'wrap',
    }}
  >
    {ADMIN_TAB_GROUPS
      .filter((group) => !group.mainAdminOnly || isMainAdmin)
      .map((group) => (
      <div
        key={group.id}
        data-testid={`admin-tab-group-${group.id}`}
        style={{
          display: 'inline-flex',
          flexDirection: 'column',
          gap: 4,
          padding: '4px 8px 6px',
          background: ADMIN_PALETTE.surfaceMuted,
          borderRadius: 14,
          border: `1px solid ${ADMIN_PALETTE.border}55`,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            fontSize: 9.5,
            fontWeight: 800,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: ADMIN_PALETTE.inkSoft,
            opacity: 0.55,
            paddingLeft: 4,
            lineHeight: 1,
          }}
        >
          {group.label}
        </span>
        <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
          {group.tabs.map((tab) => (
            <TabPill
              key={tab.id}
              tab={tab}
              active={activeTab === tab.id}
              count={tabCounts[tab.id]}
              countTone={TAB_COUNT_TONE[tab.id]}
              onClick={() => onTabClick(tab.id)}
            />
          ))}
        </div>
      </div>
      ))}
  </div>
);
